import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TThunkAction } from '../../types/redux';
import { EFiltersActionTypes, TSetRatingType } from './types';
import { TRatingType } from '../../types/filters';
import { getRating } from '../rating/getRating';

export const setType: (type: TRatingType) => TSetRatingType = actionGenerator<
  EFiltersActionTypes.SetRatingType,
  TRatingType
>(EFiltersActionTypes.SetRatingType);

export function setRatingType(typeRating: TRatingType): TThunkAction {
  return dispatch => {
    dispatch(setType(typeRating));
    dispatch(getRating());
  };
}
